import { createContext, useEffect, useReducer, useContext } from "react";
import { LiferayService } from "../../../common/services/liferay/index";
import { ApplicationPropertiesContext } from "../../../common/context/ApplicationPropertiesProvider";
import { decode_utf8, getCurrentTime, getPathName } from "../../../common/utils/utilsFunc";
import { AccessTokenContext } from "../../../common/context/AccessTokenProvider";

export const PaymentAgreementContext = createContext();

export const ACTIONS = {
  SET_BODY_SDC: "SET_BODY_SDC",
  SET_RESPONSE_SDC: "SET_RESPONSE_SDC",
  SET_BODY_VC: "SET_BODY_VC",
  SET_RESPONSE_VC: "SET_RESPONSE_VC",
  SET_LOAD_PAGE: "SET_LOAD_PAGE",
  SET_IDLIST: "SET_IDLIST",
  SET_BODY_CA: "SET_BODY_CA",
  SET_RESPONSE_CA: "SET_RESPONSE_CA",
  SET_WEB_CONTENT_TEXT_PA: "SET_WEB_CONTENT_TEXT_PA",
  SET_WEB_CONTENT_TEXT_PF: "SET_WEB_CONTENT_TEXT_PF",
  SET_ERROR: "SET_ERROR",
  SET_IDCLIENT: "SET_IDCLIENT",
  SET_DETAIL_CLIENT: "SET_DETAIL_CLIENT",
  SET_WEB_CONTENT_TEXT_INFO: "SET_WEB_CONTENT_TEXT_INFO",

  // ✅ NUEVAS ACCIONES (pre-oferta)
  SET_BODY_PREOFFER: "SET_BODY_PREOFFER",
  SET_RESPONSE_PREOFFER: "SET_RESPONSE_PREOFFER",
  SET_BODY_SPE: "SET_BODY_SPE",
  SET_RESPONSE_SPE: "SET_RESPONSE_SPE",
  SET_BODY_CPE: "SET_BODY_CPE",
  SET_RESPONSE_CPE: "SET_RESPONSE_CPE",
};

const initialState = {
  body_ca: null,
  body_vc: null,
  body_sdc: null,
  response_ca: null,
  response_vc: null,
  response_sdc: null,
  loadPage: false,
  idList: [],
  webContentTextPf: "",
  webContentTextPa: "",
  idClient: null,
  detailClient: null,
  webContentTextInfo: "",

  // ✅ NUEVO ESTADO (pre-oferta)
  body_preoffer: null,
  response_preoffer: null,
  body_spe: null,
  response_spe: null,
  body_cpe: null,
  response_cpe: null,
};

const PaymentAgreementReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTIONS.SET_BODY_CA: {
      return { ...state, body_ca: action.payload };
    }
    case ACTIONS.SET_BODY_VC: {
      return { ...state, body_vc: action.payload };
    }
    case ACTIONS.SET_RESPONSE_VC: {
      return { ...state, response_vc: action.payload };
    }
    case ACTIONS.SET_RESPONSE_SDC: {
      return { ...state, response_sdc: action.payload };
    }
    case ACTIONS.SET_RESPONSE_CA: {
      return { ...state, response_ca: action.payload };
    }
    case ACTIONS.SET_LOAD_PAGE: {
      return { ...state, loadPage: action.payload };
    }
    case ACTIONS.SET_IDLIST: {
      return { ...state, idList: action.payload };
    }
    case ACTIONS.SET_BODY_SDC: {
      return { ...state, body_sdc: action.payload };
    }
    case ACTIONS.SET_WEB_CONTENT_TEXT_PF: {
      return { ...state, webContentTextPf: action.payload };
    }
    case ACTIONS.SET_WEB_CONTENT_TEXT_PA: {
      return { ...state, webContentTextPa: action.payload };
    }
    case ACTIONS.SET_IDCLIENT: {
      return { ...state, idClient: action.payload };
    }
    case ACTIONS.SET_DETAIL_CLIENT: {
      return { ...state, detailClient: action.payload };
    }
    case ACTIONS.SET_ERROR: {
      return { ...state, errorFetch: action.payload };
    }
    case ACTIONS.SET_WEB_CONTENT_TEXT_INFO: {
      return { ...state, webContentTextInfo: action.payload };
    }

      // ✅ NUEVOS CASES (pre-oferta)
    case ACTIONS.SET_BODY_PREOFFER: {
      return { ...state, body_preoffer: action.payload };
    }
    case ACTIONS.SET_RESPONSE_PREOFFER: {
      return { ...state, response_preoffer: action.payload };
    }
    case ACTIONS.SET_BODY_SPE: {
      return { ...state, body_spe: action.payload };
    }
    case ACTIONS.SET_RESPONSE_SPE: {
      return { ...state, response_spe: action.payload };
    }
    case ACTIONS.SET_BODY_CPE: {
      return { ...state, body_cpe: action.payload };
    }
    case ACTIONS.SET_RESPONSE_CPE: {
      return { ...state, response_cpe: action.payload };
    }

    default: {
      return state;
    }
  }
};

const PaymentAgreementContextProvider = ({ children }) => {
  const properties = useContext(ApplicationPropertiesContext);
  const { accessToken } = useContext(AccessTokenContext);

  const [state, dispatch] = useReducer(PaymentAgreementReducer, initialState);

  useEffect(() => {
    if (accessToken) {
      LiferayService.getIdList(properties.base_url_api).then((response) => {
        dispatch({ payload: response, type: ACTIONS.SET_IDLIST });

        if (properties.web_content_payment_agreement) {
          LiferayService.getWebContent(
              properties.base_url_api,
              properties.web_content_payment_agreement
          ).then((response) => {
            dispatch({ payload: response, type: ACTIONS.SET_WEB_CONTENT_TEXT_PA });

            if (properties.web_content_details_payment_file) {
              LiferayService.getWebContent(
                  properties.base_url_api,
                  properties.web_content_details_payment_file
              ).then((response) => {
                dispatch({ payload: response, type: ACTIONS.SET_WEB_CONTENT_TEXT_PF });
                dispatch({ payload: false, type: ACTIONS.SET_LOAD_PAGE });
              });
            }
          });
        }
      });
    }
  }, [accessToken, properties.base_url_api, properties.web_content_payment_agreement, properties.web_content_details_payment_file]);

  useEffect(() => {
    if (state.loadPage) {
      const key = decode_utf8(properties.web_content_info_update_of_contact_information).trim();
      if (key) {
        LiferayService.getWebContent(properties.base_url_api, key).then((response) => {
          dispatch({ payload: response, type: ACTIONS.SET_WEB_CONTENT_TEXT_INFO });
        });
      }
    }
  }, [state.loadPage, properties.web_content_info_update_of_contact_information, properties.base_url_api]);

  // Valida Cliente
  useEffect(() => {
    if (state.body_vc && getPathName() === "convenio-de-pago") {
      LiferayService.getValidClient(
          properties.base_url_api,
          state.body_vc,
          properties.codigo_empresa,
          properties.url_ws_empresa
      ).then((response) => {
        if (response.code === 0) {
          dispatch({ type: ACTIONS.SET_IDCLIENT, payload: state.body_vc.numCli });
        }
        dispatch({ payload: response, type: ACTIONS.SET_RESPONSE_VC });
      });
    }
  }, [state.body_vc, properties.base_url_api, properties.codigo_empresa, properties.url_ws_empresa]);

  // Simulación del convenio
  useEffect(() => {
    if (state.body_sdc && getPathName() === "convenio-de-pago") {
      LiferayService.getSimulacionAgreement(
          properties.base_url_api,
          state.body_sdc,
          properties.codigo_empresa,
          properties.url_ws_empresa
      ).then((response) => {
        dispatch({ payload: response, type: ACTIONS.SET_RESPONSE_SDC });
      });
    }
  }, [state.body_sdc, properties.base_url_api, properties.codigo_empresa, properties.url_ws_empresa]);

  // Crear convenio
  useEffect(() => {
    if (state.body_ca && getPathName() === "convenio-de-pago") {
      LiferayService.createAgreement(
          properties.base_url_api,
          state.body_ca,
          properties.codigo_empresa,
          properties.url_ws_empresa
      ).then((response) => {
        const blob = new Blob([response], { type: "application/pdf" });
        const fileURL = URL.createObjectURL(blob);
        if (!response.status) {
          let link = document.createElement("a");
          link.download = `ConvenioDePago_${getCurrentTime()}.pdf`;
          link.href = fileURL;
          link.click();
        } else {
          response.status = 999;
        }

        dispatch({ payload: response, type: ACTIONS.SET_RESPONSE_CA });
      });
    }
  }, [state.body_ca, properties.base_url_api, properties.codigo_empresa, properties.url_ws_empresa]);

  // Detalle cuenta contrato (para llenar datos del cliente)
  useEffect(() => {
    if (state.idClient) {
      LiferayService.consultarDetalleCuentaContrato(
          properties.base_url_api,
          state.idClient,
          properties.url_ws_empresa,
          properties.codigo_empresa
      )
          .then((response) => {
            dispatch({ payload: response, type: ACTIONS.SET_DETAIL_CLIENT });
            dispatch({ payload: null, type: ACTIONS.SET_ERROR });
          })
          .catch((error) => {
            dispatch({ payload: error, type: ACTIONS.SET_ERROR });
          });
    }
  }, [state.idClient, properties.base_url_api, properties.codigo_empresa, properties.url_ws_empresa]);

  //NUEVO: Validar Convenio Especial (pre-oferta)
  useEffect(() => {
    if (state.body_preoffer && getPathName() === "convenio-de-pago") {
      LiferayService.validarConvenioPagoEspecial(
          properties.base_url_api,
          state.body_preoffer.segmento,   // Segmento (p.ej. '07')
          state.body_preoffer.numCli,     // CuentaContrato (p.ej. '9864432')
          properties.url_ws_empresa       // URL WS
      ).then((response) => {
        dispatch({ type: ACTIONS.SET_RESPONSE_PREOFFER, payload: response });
      });
    }
  }, [state.body_preoffer, properties.base_url_api, properties.url_ws_empresa]);

  // 🔁 Simular Convenio Pago Especial (se ejecuta al cambiar cuotas en el UI especial)
  useEffect(() => {
    if (state.body_spe && getPathName() === "convenio-de-pago") {
      const { monto, cuotas } = state.body_spe || {};
      console.debug("[SPE] invoking simularConvenioPagoEspecial:", { monto, cuotas });

      LiferayService.simularConvenioPagoEspecial(
          properties.base_url_api,
          { monto, cuotas },
          properties.url_ws_empresa
          // si luego necesitas captchaToken, se agrega como 4to arg
      )
          .then((response) => {
            console.debug("[SPE] response:", response);
            dispatch({ type: ACTIONS.SET_RESPONSE_SPE, payload: response });
          })
          .catch((err) => {
            console.error("[SPE] error:", err);
            dispatch({ type: ACTIONS.SET_RESPONSE_SPE, payload: { error: true } });
          });
    }
  }, [state.body_spe, properties.base_url_api, properties.url_ws_empresa]);

  useEffect(() => {
    if (state.body_cpe && getPathName() === "convenio-de-pago") {
      const payload = state.body_cpe;
      console.debug("[CPE][dispatch] body_cpe:", payload);

      LiferayService.crearConvenioPagoEspecialNotification(
          properties.base_url_api,
          payload,
          properties.url_ws_empresa
      )
          .then((data) => {
            console.debug("[CPE][service][ok] data:", data);
            dispatch({ type: ACTIONS.SET_RESPONSE_CPE, payload: data });
          })
          .catch((err) => {
            console.error("[CPE][service][err]:", err);
            dispatch({
              type: ACTIONS.SET_RESPONSE_CPE,
              payload: { codigo: 500, mensaje: "Error de red", error: true }
            });
          });
    }
  }, [state.body_cpe, properties.base_url_api, properties.url_ws_empresa]);

  return (
      <PaymentAgreementContext.Provider value={[state, dispatch]}>
        {children}
      </PaymentAgreementContext.Provider>
  );
};

export default PaymentAgreementContextProvider;